import { DocumentNode, gql, useMutation } from '@apollo/client';
import { MenuItem, useToast } from '@chakra-ui/react';
import * as React from 'react';

import { SendIcon } from '@/imports/ui/chakra/feather';

import { PostNowDropdownItem_PostFragment } from './graphql-types/PostNowDropdownItem_PostFragment';
import {
  PostNowDropdownItem_PublishDraftPost,
  PostNowDropdownItem_PublishDraftPostVariables,
} from './graphql-types/PostNowDropdownItem_PublishDraftPost';

const POST_FRAGMENT = gql`
  fragment PostNowDropdownItem_PostFragment on PostV2 {
    _id
    datePublished

    ... on BlogV2 {
      published
    }
  }
`;

const PUBLISH_NOW = gql`
  mutation PostNowDropdownItem_PublishDraftPost(
    $input: PublishDraftPostInput!
  ) {
    publishDraftPost(input: $input) {
      data {
        _id
        ...PostNowDropdownItem_PostFragment
      }
    }
  }
  ${POST_FRAGMENT}
`;

export const PostNowDropdownItem: React.FC<{
  post: PostNowDropdownItem_PostFragment;
}> & { postFragment: DocumentNode } = (props) => {
  const toast = useToast();

  const [publishNow] = useMutation<
    PostNowDropdownItem_PublishDraftPost,
    PostNowDropdownItem_PublishDraftPostVariables
  >(PUBLISH_NOW, {
    refetchQueries: ['DraftsPage_GetMyDraftPosts', 'AccountMenu_Query'],
  });

  const onPostNow = async (): Promise<void> => {
    try {
      await publishNow({
        variables: {
          input: { postId: props.post._id },
        },
        update(cache) {
          cache.modify({
            fields: {
              myDraftPosts(existingItems, { readField }) {
                return {
                  ...existingItems,
                  posts: existingItems.posts.filter(
                    (itemRef: any) =>
                      readField('_id', itemRef) !== props.post._id
                  ),
                };
              },
            },
          });
        },
      });
      toast({
        title: `Published post`,
        status: 'success',
      });
    } catch (err) {
      toast({
        title: `Failed to publish post`,
        status: 'error',
      });
    }
  };

  return (
    <MenuItem icon={<SendIcon />} onClick={onPostNow}>
      Post Now
    </MenuItem>
  );
};

PostNowDropdownItem.postFragment = POST_FRAGMENT;
